import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import HomeIcon from "@mui/icons-material/Home";
import DescriptionIcon from "@mui/icons-material/Description";
import TranslateIcon from "@mui/icons-material/Translate";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";

import CustomForm from "../../../helper-components/form/CustomForm.jsx";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter.jsx";

import AudioTranslationTable from "./components/AudioTranslationTable.jsx";

import { getLanguage } from "../../../config/language/language.js";

/**
 * The highlight requests page.
 */
export default function AudioTranslations(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().AUDIO_TRANSLATIONS_TITLE} subtitle={getLanguage().AUDIO_TRANSLATIONS_SUBTITLE} icon={<AudiotrackIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <AudioTranslationTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={2}
                    options={[
                        {
                            path: `/database/resources`,
                            title: "Resources",
                            variant: "outlined",
                            icon: <DescriptionIcon />
                        },
                        {
                            path: `/translations/text`,
                            title: "Text translations",
                            variant: "outlined",
                            icon: <TranslateIcon />
                        },
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
